//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import activateResourcesFilter from '~/mixins/ResourceFilterFunctions/resources.js';
export default {
	mixins: [activateResourcesFilter],
	async fetch() {
		await this.$store.dispatch(
			'resourcesStore/getResources',
			this.queries.shortModels
			);
	},
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: { filter } }) => filter,
			queries: ({ resourcesStore: { queries } }) => queries,
			shortModels: ({ resourcesStore: { shortModels } }) => shortModels,
		}),
		modelFilter() {
			return this.shortModels?.data
			? this.findBy(this.shortModels.data, this.query, 'title')
			: [];
		},
	},
	data() { 
		return {
			query: '',
		}
	},
	methods: {
		findBy: function (list, value, column) {
			var array = list.map((value, index) => {
				return value;
			});
			var query = value.toLowerCase();
			return array.filter(function (item) {
				var modelName = item.title.toLowerCase();
				return modelName.includes(query)
			})
		},
	}
}
